<div style="min-width: 500px">

  <div matDialogTitle>{{ type === ModalTypes.Edit ? 'Edit' : 'Create' }} {{ subGroupType === 'Change' ? 'Change' : 'Subgroup'}}</div>
  <mat-dialog-content>
    <div>
      @for (item of savingMessage; track item) {
        <p-message [severity]="item.severity">{{item.summary}}</p-message>
      }
    </div>
    @if (type === ModalTypes.Edit) {
      <p style="margin-bottom: 40px;color: black;">This will update the name and description of this {{ subGroupType === 'Change' ? 'Change' : 'Subgroup'}} across the whole studio.</p>
    }
    <form #groupForm="ngForm" class="layout-column-space-around-stretch">
      <mat-form-field class="layout-flex-20 wk-flex-fix">
        <mat-label>Group *</mat-label>
        <mat-select [(value)]="selectedGroup">
          @for (group of groupList; track group) {
            <mat-option [value]="group.id">{{group.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="wk-flex-fix">
        <mat-label>Name</mat-label>
        <input matInput value="" [(ngModel)]="subGroup.name" maxlength="255" name="name" pattern=".*\S.*"
          required>
          <mat-error>Please enter a {{ subGroupType === 'Change' ? 'Change' : 'Subgroup'}} name</mat-error>
        </mat-form-field>
        <mat-form-field class="wk-flex-fix">
          <mat-label>Description</mat-label>
          <textarea matInput matAutosizeMaxRows="5" matTextareaAutosize value="" [(ngModel)]="subGroup.description" name="description"></textarea>
        </mat-form-field>
      </form>
      @if (type === ModalTypes.Create) {
        <div class="flex-column">
          <div class="flex-1">
            <p-fileUpload #attachmentUpload name="attachmentFile[]" [accept]="accept" mode="basic" auto="true" customUpload="true" (uploadHandler)="addAttachment($event)"
            chooseLabel="Attachments" [multiple]="true"></p-fileUpload>
          </div>
          @for (attachment of attachments; track attachment) {
            <div class="flex-1" style="margin-top: 5px;">
              <div class="flex space-between align-items-stretch">
                <div class="flex-80 ellipsis">{{attachment.name}}</div>
                <div class="flex-1">
                  <mat-icon class="clickable" (click)="removeAttachment(attachment)" svgIcon="clear"></mat-icon>
                </div>
              </div>
            </div>
          }
        </div>
      }
    </mat-dialog-content>
    <mat-dialog-actions class="flex justify-flex-end gap-20">
      <button mat-raised-button matDialogClose class="flex-20 wk-flex-fix">Cancel</button>
      <button mat-raised-button (click)="save(groupForm)" [ngStyle]="{'background-color': groupForm?.form?.valid && isDisabled?'#607d8b' : '#0000001f','color':groupForm?.form?.valid && isDisabled?'#FFF':'rgba(0, 0, 0, 0.26)' }" [disabled]="!groupForm.form.valid && !isDisabled" class="flex-20 wk-flex-fix">{{ type === ModalTypes.Edit ? 'Save' : 'Create' }}</button>
    </mat-dialog-actions>
  </div>
